import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { StatusComponent } from '@shared/status';
import { FeedbackRow } from '../../feedbacks.abstraction';
import { FEEDBACK_STATUS_CONFIG } from '../../feedbacks.constant';

@Component({
  selector: 'ca-feedbacks-status-cell',
  standalone: true,
  template: ` <ca-status [status]="item().status" [config]="config" [style.width]="'100px'"/> `,
  imports: [StatusComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackStatusCellComponent {
  item = input.required<FeedbackRow>();

  config = FEEDBACK_STATUS_CONFIG;
}
